export default __webpack_public_path__ + "static/media/background.7d6eae9b.jpg";